/* eslint-disable react/prop-types */
import './index.scss';
import ModalBase from '.';
import { ModalUpdateTransactionMemoProps } from '../../types';
import { useEffect, useState } from 'react';
import { Alert, Button, Input } from '@piggytechng/component-library';
import ModalExecuteAction from './ModalExecuteAction';
import { OverideButtonStyle, OverideInputStyle } from '../../helpers/utils';

function ModalUpdateTransactionMemo({
  modalIsOpen,
  setIsOpen,
  reference,
  wallet,
  currentMemo = '',
  onUpdate,
  onSuccess,
  isLoading = false,
}: ModalUpdateTransactionMemoProps) {
  const [showActionModal, setShowActionModal] = useState(false);
  const [memo, setMemo] = useState('');

  function closeModal() {
    if (isLoading) return;
    setIsOpen(false);
    setMemo('');
  }

  const proceed = (e: React.FormEvent) => {
    e.preventDefault();

    if (!memo.trim()) {
      Alert.error('Please provide a memo to proceed');
      return;
    }

    setShowActionModal(true);
    setIsOpen(false);
    return;
  };

  const handleSubmit = async () => {
    try {
      await onUpdate(wallet, reference, memo.trim());
      setShowActionModal(false);
      setIsOpen(false);
      setMemo('');
      onSuccess && onSuccess();
    } catch (error) {
      // Error handling is done in the onUpdate function
    }
  };

  useEffect(() => {
    if (modalIsOpen) {
      setMemo(currentMemo || '');
    }
  }, [modalIsOpen, currentMemo]);

  return (
    <>
      <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
        <div className={`modal-processor`}>
          <div className="modal-processor__header">
            <h2>Update Memo</h2>
            <button onClick={closeModal}>&times;</button>
          </div>

          <form className="modal-processor__body" onSubmit={proceed}>
            <Input
              {...OverideInputStyle}
              labelStyle={{
                color: '#666766',
              }}
              label="Memo"
              placeholder="Enter memo"
              value={memo}
              onChange={(e) => setMemo(e.target.value)}
              required
            />

            <div className="modal-processor__actions">
              <button type="button" onClick={closeModal} className="modal-processor__actions-reject">
                Cancel
              </button>
              <Button {...OverideButtonStyle} className="modal-processor__actions-resolve" type="submit">
                Proceed
              </Button>
            </div>
          </form>
        </div>
      </ModalBase>

      <ModalExecuteAction
        modalIsOpen={showActionModal}
        isLoading={isLoading}
        setIsOpen={setShowActionModal}
        text="update this transaction memo?"
        action={() => handleSubmit()}
        actionColor="#1734CA"
        buttonText="Update"
      />
    </>
  );
}

export default ModalUpdateTransactionMemo;
